module.exports = __webpack_public_path__ + "static/media/mis-cursos-line.0465be2f.svg";